module.exports = __webpack_public_path__ + "static/img/icons-goods.97d35d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons-goods.png
// module id = y4XM
// module chunks = 10 11